// @flow
import type { Dispatch, GetState } from 'state/types';
import { actions } from 'portfolio-shared/state/reducers/dialogPanelReducer';
const {
  showDialogPanel: showDialogPanelAction,
  hideDialogPanel: hideDialogPanelAction,
} = actions;

export function showDialogPanel(panelId: string, data?: Object) {
  return async function showDialogPanel(
    dispatch: Dispatch,
    getState: GetState
  ) {
    return await dispatch(showDialogPanelAction(panelId, data));
  };
}

export function hideDialogPanel() {
  return hideDialogPanelAction();
}



// WEBPACK FOOTER //
// ./src/state/commands/dialogPanelCommands.js